export const BRAND = {
  red: "#C0392B",
  darkRed: "#96281B",
  gold: "#E67E22",
  dark: "#1A1A1A",
};

export const CONTACT = {
  address1: "Khasra No. 52, Lamachpur, Teh. Mundawar",
  address2: "Distt. Khairthal-Tijara (Raj.) 301706",
  address3: "All India",
  phones: ["+91-9950817883", "+91-7737817883", "+91-9887216411"],
  emails: ["info@skassociate.co", "singhbane877@gmail.com"],
  website: "www.skassociate.co",
};

export const STATS = [
  { number: "500+", label: "Projects Done" },
  { number: "50,000+", label: "Sq Ft Treated" },
  { number: "100%", label: "GST Verified" },
  { number: "10+", label: "Years Experience" },
];

export const WHY_US = [
  { icon: "🏆", title: "One-Time Treatment", desc: "Our densification system is a permanent solution — no repeat treatments needed." },
  { icon: "🔬", title: "Advanced Chemistry", desc: "Super Liquid Hardener increases concrete hardness by 65% in just 30 minutes." },
  { icon: "🛡️", title: "Dust & Stain Proof", desc: "Sealed surfaces resist dust, stains, and moisture for the life of the concrete." },
  { icon: "💰", title: "Cost Effective", desc: "Reduce maintenance costs significantly with our long-lasting floor solutions." },
  { icon: "⚙️", title: "Expert Team", desc: "Experienced professionals with proven techniques for every floor type." },
  { icon: "📋", title: "GST Verified", desc: "Fully compliant, registered business with transparent pricing and invoicing." },
];

export const IMAGES = {
  hero: "/29.png",
  warehouse: "/28.png",
  polish: "/21.png",
  concrete: "/6.png",
  team: "/36.png",
  factory: "/35.png",
  repair: "/36.png",
  cracks: "/35.png",
  maintain: "/34.png",
  about1: "/35.png",
  about2: "/36.png",
  contact: "/33.png",
  strip: [
    "/21.png",
    "./35.png",
    "/19.png",
    "/1.png",
  ],

};
